import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Input } from '@zep/ui/experimental';
import { RHFCheckboxGroup } from './RHFCehckboxGroup';
import { ThereWasProblems } from './schema';
export const ThereWasProblemContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    register,
    watch,
    resetField
  } = useFormContext();
  const flickeringProblem = watch('thereWasProblems.flickeringProblem');
  const otherFeatures = watch('thereWasProblems.otherFeatures');
  useEffect(() => {
    if (!flickeringProblem) {
      resetField('thereWasProblems.flickeringProblemReason');
    }
    if (!otherFeatures) {
      resetField('thereWasProblems.otherReason');
    }
  }, [flickeringProblem, otherFeatures, resetField]);
  return <div className="flex flex-col gap-[8px]" data-sentry-component="ThereWasProblemContent" data-sentry-source-file="ThereWasProblemContent.tsx">
      <p className="text-body-2-m whitespace-pre text-wrap text-gray-600">
        {t('subscription:unsubscribe.f685c65e', '어떤 문제가 있었나요?')}
      </p>
      <RHFCheckboxGroup<ThereWasProblems> key={'thereWasProblems.rtcSharingProblem'} name={'thereWasProblems.rtcSharingProblem'} label={t('subscription:unsubscribe.02266ee0', '비디오/오디오 공유에 문제가 있었어요')} data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="ThereWasProblemContent.tsx" />
      <RHFCheckboxGroup<ThereWasProblems> key={'thereWasProblems.connectionProblem'} name={'thereWasProblems.connectionProblem'} label={t('subscription:unsubscribe.7c57f752', '스페이스 접속이 원활하지 않았어요')} data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="ThereWasProblemContent.tsx" />
      <RHFCheckboxGroup<ThereWasProblems> key={'thereWasProblems.flickeringProblem'} name={'thereWasProblems.flickeringProblem'} label={t('subscription:unsubscribe.3721dc6d', '사용 시 버벅임이 심해요')} description={t('subscription:unsubscribe.4e5b5129', '구체적으로 작성해 주시면 서비스 개선에 적극 반영하겠습니다.')} contentClassName="!mt-[8px] !py-0" data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="ThereWasProblemContent.tsx">
        <Input placeholder={t('subscription:unsubscribe.e66a6d1d', '사용 기기와 브라우저를 입력해 주세요 (필수)')} className="h-[40px] w-full" {...register('thereWasProblems.flickeringProblemReason')} data-sentry-element="Input" data-sentry-source-file="ThereWasProblemContent.tsx" />
      </RHFCheckboxGroup>
      <RHFCheckboxGroup<ThereWasProblems> key={'thereWasProblems.otherFeatures'} name={'thereWasProblems.otherFeatures'} label={t('subscription:unsubscribe.ca5582bc', '기타')} description={t('subscription:unsubscribe.4e5b5129', '구체적으로 작성해 주시면 서비스 개선에 적극 반영하겠습니다.')} contentClassName="!mt-[8px] !py-0" data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="ThereWasProblemContent.tsx">
        <Input placeholder={t('subscription:unsubscribe.cafe215a', '에러 내용을 입력해 주세요 (필수)')} className="h-[40px] w-full" {...register('thereWasProblems.otherReason')} data-sentry-element="Input" data-sentry-source-file="ThereWasProblemContent.tsx" />
      </RHFCheckboxGroup>
    </div>;
};